"use strict";
/* eslint-disable global-require */
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    EnvelopeType: () => require('./envelopeType').default,
    AppointmentType: () => require('./appointmentType').default,
    ApiTransaction: () => require('./apiTransaction').default,
    Action: () => require('./action').default,
    ActionsForCustomer: () => require('./actionsForCustomer').default,
    FilesForCustomer: () => require('./filesForCustomer').default,
    LastMessageInThread: () => require('./lastMessageInThread').default,
    AdminAuditTrail: () => require('./adminAuditTrail').default,
    Address: () => require('./address').default,
    AppVersion: () => require('./appVersion').default,
    ArchiveBatch: () => require('./archiveBatch').default,
    ArchiveBatchToItem: () => require('./archiveBatchToItem').default,
    Attachment: () => require('./attachment').default,
    AuditTrail: () => require('./auditTrail').default,
    AuthConfig: () => require('./authConfig').default,
    BlockedUsers: () => require('./blockedUsers').default,
    AccountVerification: () => require('./accountVerification').default,
    BookingDateException: () => require('./bookingDateException').default,
    BusinessTypes: () => require('./businessTypes').default,
    MobileNumbersWhitelist: () => require('./mobileNumbersWhitelist').default,
    Checkin: () => require('./checkin').default,
    CisRate: () => require('./cisRate').default,
    Cohort: () => require('./cohort').default,
    ColorScheme: () => require('./colorScheme').default,
    Company: () => require('./company').default,
    CompanyAddress: () => require('./companyAddress').default,
    CompanyForm: () => require('./companyForm').default,
    CompanyIntegration: () => require('./companyIntegration').default,
    CompanySettings: () => require('./companySettings').default,
    CompanyStats: () => require('./companyStats').default,
    ConsumptionExtra: () => require('./consumptionExtra').default,
    ConsumptionStats: () => require('./consumptionStats').default,
    Contact: () => require('./contact').default,
    ContactMethod: () => require('./contactMethod').default,
    ContactMethodType: () => require('./contactMethodType').default,
    ContactToAddress: () => require('./contactToAddress').default,
    ContactWithHeaders: () => require('./contactWithHeaders').default,
    Country: () => require('./country').default,
    CountryCurrency: () => require('./countryCurrency').default,
    CountryFeature: () => require('./countryFeature').default,
    CountryGroup: () => require('./countryGroup').default,
    CountryToCountryGroup: () => require('./countryToCountryGroup').default,
    Currency: () => require('./currency').default,
    Customer: () => require('./customer').default,
    DataEmitterConfig: () => require('./dataEmitterConfig').default,
    Device: () => require('./device').default,
    DeviceSync: () => require('./deviceSync').default,
    Document: () => require('./document/index').default,
    DocumentAction: () => require('./documentAction').default,
    DocumentContent: () => require('./documentContent').default,
    DocumentItem: () => require('./documentItem').default,
    DocumentLayout: () => require('./documentLayout').default,
    DocumentLogo: () => require('./documentLogo').default,
    DocumentWithHeaders: () => require('./documentWithHeaders').default,
    EasyNote: () => require('./easyNote').default,
    Feature: () => require('./feature').default,
    File: () => require('./file').default,
    FileGroup: () => require('./fileGroup').default,
    Form: () => require('./form').default,
    FormCategory: () => require('./formCategory').default,
    FormDocument: () => require('./formDocument').default,
    FormDocumentWithHeaders: () => require('./formDocumentWithHeaders').default,
    FormType: () => require('./formType').default,
    GlobalConfig: () => require('./globalConfig').default,
    GlobalProductTemplates: () => require('./globalProductTemplates').default,
    Icon: () => require('./icon').default,
    IconType: () => require('./iconType').default,
    IconTypeToIcon: () => require('./iconTypeToIcon').default,
    IncrementalNumber: () => require('./incrementalNumber').default,
    IntegrationCategory: () => require('./integrationCategory').default,
    IntegrationType: () => require('./integrationType').default,
    Job: () => require('./job').default,
    JobItem: () => require('./jobItem').default,
    JobItemGroup: () => require('./jobItemGroup').default,
    JobStatus: () => require('./jobStatus').default,
    JobStats: () => require('./jobStats').default,
    KnownError: () => require('./knownError').default,
    Language: () => require('./language').default,
    LockDate: () => require('./lockDate').default,
    LogoCollection: () => require('./logoCollection').default,
    LogoCollectionCategory: () => require('./logoCollectionCategory').default,
    Media: () => require('./media').default,
    MediaGroup: () => require('./mediaGroup').default,
    CustomerMessage: () => require('./customerMessage').default,
    CustomerMessageAttachment: () => require('./customerMessageAttachment').default,
    MessageRecipient: () => require('./messageRecipient').default,
    Message: () => require('./message').default,
    MessageTemplate: () => require('./messageTemplate').default,
    MessageAttachments: () => require('./messageAttachments').default,
    MessageStatus: () => require('./messageStatus').default,
    Metrics: () => require('./metrics').default,
    MetricsRange: () => require('./metricsRange').default,
    Note: () => require('./note').default,
    OnlineSync: () => require('./onlineSync').default,
    PartnerCatalog: () => require('./partnerCatalog').default,
    PartnerCatalogAvailability: () => require('./partnerCatalogAvailability').default,
    PartnerCatalogData: () => require('./partnerCatalogData').default,
    PartnerCatalogDocument: () => require('./partnerCatalogDocument').default,
    Payment: () => require('./payment').default,
    PaymentsForCustomer: () => require('./paymentsForCustomer').default,
    PaymentDetails: () => require('./paymentDetails').default,
    PaymentSetting: () => require('./paymentSetting').default,
    PaymentToInvoice: () => require('./paymentToInvoice').default,
    PaymentType: () => require('./paymentType').default,
    PaymentTypeToCountry: () => require('./paymentTypeToCountry').default,
    PaymentWithHeaders: () => require('./paymentWithHeaders').default,
    Product: () => require('./product').default,
    ProductTier: () => require('./productTier').default,
    ProductTierToSubscription: () => require('./productTierToSubscription').default,
    ProductTierToFeature: () => require('./productTierToFeature').default,
    ProductFeature: () => require('./productFeature').default,
    ProductCategory: () => require('./productCategory').default,
    Prompt: () => require('./prompt').default,
    PurchaseAction: () => require('./purchaseAction').default,
    PurchaseSetup: () => require('./purchaseSetup').default,
    PurchaseSetupToPurchaseSetup: () => require('./purchaseSetupToPurchaseSetup').default,
    Purchases: () => require('./purchases').default,
    Roles: () => require('./roles').default,
    RolesUsers: () => require('./rolesUsers').default,
    Settings: () => require('./settings').default,
    SettingsKeys: () => require('./settingsKeys').default,
    Signature: () => require('./signature').default,
    Stats: () => require('./stats').default,
    SubscriptionStats: () => require('./subscriptionStats').default,
    SystemAttachment: () => require('./systemAttachment').default,
    TableVersion: () => require('./tableVersion').default,
    TaxHistory: () => require('./taxHistory').default,
    TaxRate: () => require('./taxRate').default,
    TimeLog: () => require('./timeLog').default,
    Units: () => require('./units').default,
    UsageHistory: () => require('./usageHistory').default,
    User: () => require('./user').default,
    UserToContact: () => require('./userToContact').default,
    UserMedia: () => require('./userMedia').default,
    UserMediaType: () => require('./userMediaType').default,
    UserToAddress: () => require('./userToAddress').default,
    UserAction: () => require('./userAction').default,
    UserDevice: () => require('./userDevice').default,
    UserProductTemplates: () => require('./userProductTemplates').default,
    UserProfile: () => require('./userProfile').default,
    UserProfileRole: () => require('./userProfileRole').default,
    UserProfileRoleCustom: () => require('./userProfileRoleCustom').default,
    UserSettings: () => require('./userSettings').default,
    UserTaxRate: () => require('./userTaxRate/index').default,
    UserTaxRateFilter: () => require('./userTaxRateFilter').default,
    UserUserProfile: () => require('./userUserProfile').default,
    WhiteLabel: () => require('./whiteLabel').default,
    WhiteLabelMetrics: () => require('./whiteLabelMetrics').default,
    WhiteLabelToAppVersion: () => require('./whiteLabelToAppVersion').default,
    WhiteLabelToCountry: () => require('./whiteLabelToCountry').default,
    WhiteLabelToCustomer: () => require('./whiteLabelToCustomer').default,
    CompanyPhoneNumber: () => require('./companyPhoneNumber').default,
    Workflow: () => require('./workflow').default,
    CompanyWorkflow: () => require('./companyWorkflow').default,
    IdempotentRecordCreation: () => require('./idempotentRecordCreation').default,
    ApplicationError: () => require('./ApplicationError').default,
    Chat: () => require('./chat').default,
    ClientError: () => require('./clientError').default,
    Delay: () => require('./delay').default,
    Location: () => require('./location').default,
    LoginSessions: () => require('./loginSessions').default,
    MessageQueueFail: () => require('./messageQueueFail').default,
    NotificationLog: () => require('./notificationLog').default,
    TokenData: () => require('./tokenData').default,
    TransactionLog: () => require('./transactionLog').default,
    DocumentToDocument: () => require('./documentToDocument').default,
};
//# sourceMappingURL=../../../src/models/allModels.js.map